export const BASE_URL =
	(typeof import.meta !== "undefined" && import.meta.env
		? import.meta.env.VITE_PUBLIC_BASE_URL
		: undefined) ??
	(typeof process !== "undefined"
		? process.env.VITE_PUBLIC_BASE_URL || process.env.PUBLIC_BASE_URL
		: undefined) ??
	"https://craftlayer.in";

export const IMAGEKIT_BASE =
	(typeof import.meta !== "undefined" && import.meta.env
		? import.meta.env.VITE_IMAGEKIT_BASE
		: undefined) ??
	(typeof process !== "undefined"
		? process.env.VITE_IMAGEKIT_BASE || process.env.IMAGEKIT_BASE
		: undefined) ??
	"https://ik.imagekit.io/a2m5mxtn7b/CraftLayer";

// Google Tag Manager
export const GTM_ID = "GTM-WM34DNXJ";

// Contact Information
export const CONTACT_INFO = {
	telephone: "+91 83001 67905",
	email: "hello@craftlayer.in",
	address: {
		locality: "Bangalore",
		country: "IN",
	},
} as const;

// Social Links
export const SOCIAL_LINKS = {
	instagram: "https://www.instagram.com/CraftLayer.in/",
	linkedin: "https://www.linkedin.com/company/craftlayer",
	twitter: "https://x.com/CraftLayer_in",
	facebook: "https://www.facebook.com/profile.php?id=61584609458288",
	github: "https://github.com/craftlayer",
} as const;

export const RESEND_API_KEY =
	(typeof import.meta !== "undefined" && import.meta.env
		? import.meta.env.VITE_RESEND_API_KEY
		: undefined) ??
	(typeof process !== "undefined"
		? process.env.VITE_RESEND_API_KEY || process.env.RESEND_API_KEY
		: undefined);
